'use strict';

angular.module('userRequestEditControllers')

.controller('NavigateSystemTypeController', ['$scope', function ($scope) {

    // Update Navigation
    var updateNavivation = function () {
        var withSearch = $scope.ctxSearchSystem.withSearch();

        var filterOnSearchSystemTypeIDs = function (st) {
            if (withSearch !== true) return true;

            return !_.isUndefined(_.find($scope.ctxSearchSystem.systemTypeIDs, function (id) {
                return id === st.SystemTypeID
            }))
        }

        $scope.nextSystemType = _.chain($scope.systemTypes)
                                 .filter(filterOnSearchSystemTypeIDs)
                                 .filter(function (st) { return st.Name > $scope.systemType.Name; })
                                 .sortBy('Name')
                                 .first()
                                 .value();
        $scope.prevSystemType = _.chain($scope.systemTypes)
                                 .filter(filterOnSearchSystemTypeIDs)
                                 .filter(function (st) { return st.Name < $scope.systemType.Name; })
                                 .sortBy('Name')
                                 .last()
                                 .value();
    }

    $scope.$watch('ctxSearchSystem.systemTypeIDs', function (newValue) { updateNavivation(); }, true);
}]);